<div hidden>
    <ng-template #loading>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>
<p-dialog [visible]="true" [closable]="false" header="Add Group" [style]="{ 'min-width': '25vw' }">
    <form [formGroup]="addGroupsForm" #addForm="ngForm">
        <div *ngIf="groupTypes as items; else loading" class="mt-3 w-full">
            <p-floatlabel variant="on">
                <p-select
                    styleClass="w-full"
                    inputId="gcddl"
                    [options]="items"
                    formControlName="groupTypes"
                    dataKey="Categoryid"
                    optionLabel="GroupType"
                ></p-select>
                <label for="gcddl">Group Category</label>
            </p-floatlabel>
        </div>

        <p-floatlabel variant="on" class="my-4 w-full">
            <input
                class="w-full"
                inputId="gn"
                type="text"
                formControlName="groupName"
                pInputText
            />
            <label for="gn">Group Name</label>
        </p-floatlabel>

        <p-iftalabel class="w-full">
            <textarea
                class="w-full"
                inputId="p"
                pTextarea
                rows="5"
                cols="30"
                formControlName="purpose"
                style="resize: none"
            ></textarea>
            <label for="p">Group Purpose</label>
        </p-iftalabel>

    </form>
    <ng-template #footer>
        <button pButton pRipple text severity="danger" label="Cancel" (click)="cancelAdd()"></button>
        <button pButton pRipple text severity="success" label="Submit" (click)="saveGroup()"></button>
    </ng-template>
</p-dialog>

<!-- <p-dialog [visible]="true" [closable]="false" [showHeader]="false">
    <div id="groupAddDialog">
        <div hidden>
            <ng-template #loading>
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </ng-template>
        </div>
        <div>
            <mat-dialog-content style="min-width: 5vw; align-content: center;">
                <form [formGroup]="addGroupsForm">
                    <label style="align-self: center;">Add a Group</label>
                    <fieldset name="addGroupFieldSet">
                        <div
                            *ngIf="groupTypes as items; else loading"
                            style="padding-bottom: 2vh; padding-top: 2vh;"
                        >
                            <span class="p-float-label">
                                <p-dropdown
                                    [virtualScroll]="true"
                                    itemSize="32"
                                    id="float-dd"
                                    [autoDisplayFirst]="false"
                                    [options]="items"
                                    formControlName="groupTypes"
                                    dataKey="Categoryid"
                                    optionLabel="GroupType"
                                    autofocus
                                    placeholder="Group Category"
                                ></p-dropdown>
                                <label for="float-dd">Group Category</label>
                            </span>
                        </div>

                        <span
                            class="p-float-label"
                            style="padding-bottom: 1vh;"
                        >
                            <input
                                id="float-input"
                                type="text"
                                formControlName="groupName"
                                pInputText
                            />
                            <label for="float-input">Group Name</label>
                        </span>

                        <div style="padding-top: 1vh;">
                            <span class="p-float-label">
                                <textarea
                                    id="float-textarea"
                                    pInputTextarea
                                    autoResize="autoResize"
                                    formControlName="purpose"
                                ></textarea>
                                <label for="float-textarea"
                                    >Group Purpose</label
                                >
                            </span>
                        </div>
                    </fieldset>
                </form>
            </mat-dialog-content>
            <div class="button-bar button-bar-center">
                <p-button
                    #saveGroup
                    label="Save"
                    styleClass="p-button-primary"
                ></p-button>
                <p-button
                    #cancel
                    label="Cancel"
                    styleClass="p-button-danger"
                ></p-button>
            </div>
        </div>
    </div>
</p-dialog> -->
